var WDN = WDN || {};

if (typeof WDN.SimpleForm === "undefined") {
  WDN.SimpleForm = (function () {

    class SimpleForm extends HTMLElement {
      constructor() {
        super();
      }
      get nodeForm() {
        return {
          form: this.querySelector("form") ? this.querySelector("form") : null,
          inputs: this.querySelectorAll("form input") ? this.querySelectorAll("form input") : null,
          submit: this.querySelector("form button"),
        };
      }
      get formData() {
        return this.nodeForm.form ? new FormData(this.nodeForm.form) : false;
      }
      get loading() {
        return this.hasAttribute("loading");
      }
      get state() {
        return this.getAttribute("state");
      }

      get submitState() {
        return this.nodeForm.submit.getAttribute("data-state");
      }

      set loading(state) {
        Boolean(state) ? this.setAttribute("loading", "loading") : this.removeAttribute("loading");
      }
      set formData(data) {
        this.data = data;
      }
      set state(bool) {
        Boolean(bool) ? this.setAttribute("state", "success") : this.setAttribute("state", "error");
      }

      set submitState(newState) {
        this.nodeForm.submit.setAttribute("data-state", newState);
      }

      connectedCallback() {
        this.submitState = "default";
        this.eventSubmit(this.nodeForm.form);
      }
      eventSubmit(node) {
        if (!node) return;
        node.addEventListener("submit", this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        this.loading = event;
        this.submitState = "loading";
        if (!this.nodeForm.inputs) return null;
        this.nodeForm.inputs.forEach((input) => {
          this.state = Boolean(input.value != "");
        });
        let resultObject = {
          message: "THANK YOU FOR SUBMITTING",
          state: true,
          data: this.formData,
        };
        if (this.state == "error") {
          resultObject = { message: "THERE WAS AN ERROR!", state: false };
        }
        if (resultObject.data) this.formData = resultObject.data;
        let customEvent = new CustomEvent("simple-form:submit", {
          bubbles: true,
          detail: {
            message: resultObject.message,
            state: resultObject.state,
            data: resultObject.state ? resultObject.data : null,
          },
        });

        this.dispatchEvent(customEvent);
        this.loading = false;
        this.submitState = "success";

        setTimeout(() => {
          this.submitState = "default";
        }, 800);
      }
    }

    customElements.define("simple-form", SimpleForm);

    return SimpleForm;
  })();
}
